<script lang="ts">
	import SeoInfoPage from "$lib/ui/home/seo/SeoInfoPage.svelte";
  import SeoPromoPage from "$lib/ui/home/seo/SeoPromoPage.svelte";
	import type { PageServerData } from "./$types";

	export let data: PageServerData;
	
</script>

{#if data.page?.type === 'info'}
	<SeoInfoPage {data} />
{:else}
	<SeoPromoPage {data} />
{/if}



